import { Filter } from "@companion-core/shared/app/Components/Inputs/JPInputFilter/JPInputFilter.model";

export const formatFilters = (filters?: Filter[], search?: string) => {
  const searchParams: Record<string, string> = {};
  if (search) searchParams.search = search;
  filters?.map((filter) => {
    let options = "";
    for (let i = 0; i < filter.options.length; i++) {
      if (filter.options[i].checked)
        options += `${options.length > 0 ? "," : ""}${filter.options[i].key}`;
    }
    if (options === "") return;
    searchParams[filter.name] = options;
  });
  return searchParams;
};

export const populateFilters = (filters: Filter[], params: Record<string, string | null>) => {
  const populatedFilters = [...filters];
  Object.entries(params).map(([key, value]) => {
    const filterIndex = populatedFilters.findIndex((value) => value.name === key);
    if (filterIndex === -1) return;
    const filterValues = value?.split(",");
    filterValues?.map((filterValue) => {
      const filterValueIndex = populatedFilters[filterIndex].options.findIndex(
        (option) => option.key === filterValue
      );
      if (filterValueIndex === -1) return;
      populatedFilters[filterIndex].options[filterValueIndex].checked = true;
    });
  });
  return populatedFilters;
};
